import httpUtil from "../assets/script/utils/http";

const state = {
  info: null
};

const mutations = {};

const actions = {
  async ALogin(context, params) {
    return await httpUtil.post("/login/userlogin", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
